import { IMapper } from '@/mappers/index'
import { IPayments, IPaymentsResponse } from '@/types/payments'

export const paymentsMap: IMapper<IPaymentsResponse, IPayments> = {
  accrual_id: 'accrualId',
  amount: 'amount',
  bank_name: 'bankName',
  bik: 'bik',
  created_at: 'createdAt',
  deleted_at: 'deletedAt',
  email: 'email',
  fee: 'fee',
  payer_name: 'payerName',
  id: 'id',
  inn: 'inn',
  kpp: 'kpp',
  ks: 'ks',
  laravel_through_key: 'laravelThroughKey',
  oktmo: 'oktmo',
  payment_data: 'paymentData',
  personal_account_id: 'personalAccountId',
  ps_id: 'psId',
  ps_transaction_id: 'psTransactionId',
  receiver_name: 'receiverName',
  rs: 'rs',
  status: 'status',
  type: 'type',
  updated_at: 'updatedAt',
  user_id: 'userId'
}
